import PropTypes from 'prop-types';
import { MediaQuery, Spinner, Colors } from '@spotahome/ui-library';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Tooltip,
  CartesianGrid
} from 'recharts';

import './styles.scss';
import ChartTooltip from '../ChartTooltip/ChartTooltip';

const { isMobileScreen, isPhabletScreen, isTabletScreen } = MediaQuery;

const mobileBarSize = 15;
const desktopBarSize = 45;
const chartHeight = 300;
const chartMinWidth = 380;

const defaultValueFormatter = value => value;

const VerticalBarChart = ({
  loading = false,
  data,
  valueFormatter = defaultValueFormatter
}) => {
  const isMobileOrTablet = () =>
    isMobileScreen() || isPhabletScreen() || isTabletScreen();

  const barSize = isMobileOrTablet() ? mobileBarSize : desktopBarSize;

  if (loading) {
    return (
      <ResponsiveContainer
        width="100%"
        height={chartHeight}
        className="chart-spinner"
      >
        <Spinner />
      </ResponsiveContainer>
    );
  }

  return (
    <div className="vertical-bar-chart__container">
      <ResponsiveContainer
        width="100%"
        height={chartHeight}
        minWidth={chartMinWidth}
      >
        <BarChart data={data} barGap={4} barSize={barSize}>
          <CartesianGrid strokeDasharray="4 0" stroke={Colors['ultra-light']} />
          <XAxis
            dataKey="label"
            tickLine={false}
            fill={Colors.medium}
            fontSize={12}
            tickMargin={10}
          />
          <YAxis
            domain={[0, 100]}
            tickLine={false}
            fontSize={12}
            fill={Colors.medium}
            tickFormatter={valueFormatter}
          />
          <Tooltip
            cursor={{ fill: 'transparent' }}
            content={<ChartTooltip valueFormatter={valueFormatter} />}
          />
          <Bar
            dataKey="percentage"
            fill={Colors.interaction}
            background={{ fill: Colors['ultra-light'], radius: 100 }}
            radius={[100, 100, 100, 100]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default VerticalBarChart;

VerticalBarChart.propTypes = {
  loading: PropTypes.bool,
  valueFormatter: PropTypes.func,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      percentage: PropTypes.number
    })
  ).isRequired
};
